<div class="content">
  <!-- Header -->
  <header class="header">
    <h1 class="headline">Bienvenue sur votre modèle</h1>
    <img
      class="logo"
      src="assets/img/baseline.svg"
      alt="Logo de l'application"
    />
  </header>

  <!-- Meta line -->
  <div class="meta">
    <div class="meta-item">
      <span class="meta-label">Nom du modèle : </span>
      <span class="meta-value">{{ modelName }}</span>
    </div>
    <div class="meta-item">
      <span class="meta-label">Version du modèle : </span>
      <span class="meta-value">{{ modelVersion }}</span>
    </div>
  </div>

  <!-- Scrollable accordion area -->
  <section class="accordion-wrap">
    <mat-accordion [multi]="true" displayMode="flat">
      @for (info of infos; track $index) {
      <mat-expansion-panel [expanded]="$index === 0">
        <mat-expansion-panel-header>
          <mat-panel-title>{{ info.title }}</mat-panel-title>
        </mat-expansion-panel-header>
        <div
          [innerHTML]="info.htmlContent | formatNumbersHtml"
          class="html"
        ></div>
      </mat-expansion-panel>
      }
    </mat-accordion>
  </section>

  <!-- CTA -->
  <footer class="cta">
    <button mat-flat-button (click)="onClickButton()">
      Découvrir le modèle
    </button>
  </footer>
</div>

<div class="decoration plus">
  <div class="container">
    <div class="x"></div>
    <div class="y"></div>
  </div>
</div>
<div class="decoration block"></div>
